<template>
  <header :class="active ? 'active-header' : 'display-glass-header'">
    <div class="display-brand">
      <img v-if="companyLogo" :src="companyLogo" alt="logo" />
      <div v-else class="display-logo-fallback">{{ companyInitial }}</div>
    </div>
    <div :class="active ? 'active-branch' : 'display-branch'">
      <strong>{{ branchName || '-' }}</strong>
      <span>{{ $t('customerDisplay.idleHeader') }}</span>
    </div>
    <div :class="active ? 'active-source' : 'display-status'">
      <strong>{{ active ? $t('customerDisplay.preInvoiceKh') : $t('customerDisplay.waitingDataKh') }}</strong>
      <span>{{ active ? $t('customerDisplay.preInvoiceEn') : $t('customerDisplay.waitingDataEn') }}</span>
    </div>
  </header>
</template>

<script>
export default {
  name: 'CustomerDisplayHeader',
  props: {
    active: { type: Boolean, default: false },
    branchName: { type: String, default: '' },
    companyInitial: { type: String, default: 'T' },
    companyLogo: { type: String, default: '' }
  }
}
</script>
